"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f103 = void 0;
exports.f103 = {
    "ga": [
        "Latn",
        "Latg",
        "Ogam"
    ],
    "gaa": [
        "Latn",
        "Arab"
    ],
    "gab": [
        "Latn"
    ],
    "gac": [
        "Zyyy"
    ],
    "gad": [
        "Latn"
    ],
    "gae": [
        "Latn"
    ],
    "gaf": [
        "Latn"
    ],
    "gag": [
        "Latn",
        "Cyrl",
        "Grek"
    ],
    "gah": [
        "Latn"
    ],
    "gai": [
        "Latn"
    ],
    "gaj": [
        "Latn"
    ],
    "gak": [
        "Latn"
    ],
    "gal": [
        "Latn"
    ],
    "gam": [
        "Latn"
    ],
    "gan": [
        "Hans",
        "Hant",
        "Latn"
    ],
    "gao": [
        "Latn"
    ],
    "gap": [
        "Latn"
    ],
    "gaq": [
        "Orya"
    ],
    "gar": [
        "Latn"
    ],
    "gas": [
        "Gujr"
    ],
    "gat": [
        "Latn"
    ],
    "gau": [
        "Telu"
    ],
    "gaw": [
        "Latn"
    ],
    "gax": [
        "Latn",
        "Ethi"
    ],
    "gay": [
        "Latn"
    ],
    "gba": [
        "Latn",
        "Arab"
    ],
    "gbb": [
        "Latn"
    ],
    "gbd": [
        "Latn"
    ],
    "gbe": [
        "Latn"
    ],
    "gbf": [
        "Latn"
    ],
    "gbg": [
        "Latn"
    ],
    "gbh": [
        "Latn"
    ],
    "gbi": [
        "Latn"
    ],
    "gbj": [
        "Orya"
    ],
    "gbk": [
        "Deva",
        "Takr"
    ],
    "gbl": [
        "Gujr",
        "Deva"
    ],
    "gbm": [
        "Deva"
    ],
    "gbn": [
        "Latn"
    ],
    "gbp": [
        "Latn"
    ],
    "gbq": [
        "Latn"
    ],
    "gbr": [
        "Latn"
    ],
    "gbs": [
        "Latn"
    ],
    "gbu": [
        "Latn"
    ],
    "gbv": [
        "Latn"
    ],
    "gbw": [
        "Latn"
    ],
    "gbx": [
        "Latn"
    ],
    "gby": [
        "Latn"
    ],
    "gbz": [
        "Arab"
    ],
    "gcc": [
        "Latn"
    ],
    "gcd": [
        "Latn"
    ],
    "gce": [
        "Zyyy"
    ],
    "gcf": [
        "Latn"
    ],
    "gcl": [
        "Latn"
    ],
    "gcn": [
        "Latn"
    ],
    "gcr": [
        "Latn"
    ],
    "gct": [
        "Latn"
    ],
    "gd": [
        "Latn"
    ],
    "gda": [
        "Zyyy"
    ],
    "gdb": [
        "Orya",
        "Telu"
    ],
    "gdc": [
        "Latn"
    ],
    "gdd": [
        "Latn"
    ],
    "gde": [
        "Latn"
    ],
    "gdf": [
        "Latn"
    ],
    "gdg": [
        "Latn"
    ],
    "gdh": [
        "Latn"
    ],
    "gdi": [
        "Latn"
    ],
    "gdj": [
        "Latn"
    ],
    "gdk": [
        "Latn"
    ],
    "gdl": [
        "Latn",
        "Ethi"
    ],
    "gdm": [
        "Latn"
    ],
    "gdn": [
        "Latn"
    ],
    "gdo": [
        "Cyrl"
    ],
    "gdq": [
        "Latn"
    ],
    "gdr": [
        "Latn"
    ],
    "gds": [
        "Zxxx"
    ],
    "gdt": [
        "Latn"
    ],
    "gdu": [
        "Latn"
    ],
    "gdx": [
        "Zyyy"
    ],
    "gea": [
        "Latn"
    ],
    "geb": [
        "Latn"
    ],
    "gec": [
        "Latn"
    ],
    "ged": [
        "Latn"
    ],
    "gef": [
        "Latn"
    ],
    "geg": [
        "Latn"
    ],
    "geh": [
        "Latn"
    ],
    "gei": [
        "Latn"
    ],
    "gej": [
        "Latn"
    ],
    "gek": [
        "Latn"
    ],
    "gel": [
        "Latn"
    ],
    "geq": [
        "Latn"
    ],
    "ges": [
        "Latn"
    ],
    "gev": [
        "Latn"
    ],
    "gew": [
        "Latn"
    ],
    "gex": [
        "Latn"
    ],
    "gey": [
        "Latn"
    ],
    "gez": [
        "Ethi"
    ],
    "gfk": [
        "Latn"
    ],
    "gft": [
        "Zyyy"
    ],
    "gga": [
        "Latn"
    ],
    "ggb": [
        "Latn"
    ],
    "ggd": [
        "Latn"
    ],
    "gge": [
        "Latn"
    ],
    "ggg": [
        "Arab"
    ],
    "ggk": [
        "Latn"
    ],
    "ggl": [
        "Latn"
    ],
    "ggt": [
        "Latn"
    ],
    "ggu": [
        "Latn"
    ],
    "ggw": [
        "Latn"
    ],
    "gha": [
        "Zyyy"
    ],
    "ghc": [
        "Latn"
    ],
    "ghe": [
        "Deva"
    ],
    "ghh": [
        "Zyyy"
    ],
    "ghk": [
        "Latn"
    ],
    "ghl": [
        "Zyyy"
    ],
    "ghn": [
        "Latn"
    ],
    "gho": [
        "Zyyy"
    ],
    "ghr": [
        "Arab"
    ],
    "ghs": [
        "Latn"
    ],
    "ght": [
        "Tibt"
    ],
    "gia": [
        "Latn"
    ],
    "gib": [
        "Latn"
    ],
    "gic": [
        "Latn"
    ],
    "gid": [
        "Latn"
    ],
    "gie": [
        "Latn"
    ],
    "gig": [
        "Arab"
    ],
    "gih": [
        "Latn"
    ],
    "gii": [
        "Zyyy"
    ],
    "gil": [
        "Latn"
    ],
    "gim": [
        "Latn"
    ],
    "gin": [
        "Cyrl"
    ],
    "gip": [
        "Latn"
    ],
    "giq": [
        "Latn"
    ],
    "gir": [
        "Latn"
    ],
    "gis": [
        "Latn"
    ],
    "git": [
        "Latn"
    ],
    "giu": [
        "Zyyy"
    ],
    "giw": [
        "Zyyy"
    ],
    "gix": [
        "Latn"
    ],
    "giy": [
        "Latn"
    ],
    "giz": [
        "Latn"
    ],
    "gjk": [
        "Arab",
        "Gujr"
    ],
    "gjm": [
        "Latn"
    ],
    "gjn": [
        "Latn",
        "Arab"
    ],
    "gjr": [
        "Latn"
    ],
    "gju": [
        "Arab",
        "Deva"
    ],
    "gka": [
        "Latn"
    ],
    "gkd": [
        "Latn"
    ],
    "gke": [
        "Latn"
    ],
    "gkn": [
        "Latn"
    ],
    "gko": [
        "Latn"
    ],
    "gkp": [
        "Latn"
    ],
    "gku": [
        "Latn"
    ],
    "gl": [
        "Latn"
    ],
    "glb": [
        "Latn"
    ],
    "glc": [
        "Latn"
    ],
    "gld": [
        "Cyrl"
    ],
    "glh": [
        "Arab"
    ],
    "glj": [
        "Latn"
    ],
    "glk": [
        "Arab",
        "Latn"
    ],
    "gll": [
        "Latn"
    ],
    "glo": [
        "Latn"
    ],
    "glr": [
        "Latn"
    ],
    "glu": [
        "Latn"
    ],
    "glw": [
        "Latn"
    ],
    "gly": [
        "Zyyy"
    ],
    "gma": [
        "Latn"
    ],
    "gmb": [
        "Latn"
    ],
    "gmd": [
        "Latn"
    ],
    "gmg": [
        "Latn"
    ],
    "gmh": [
        "Latn"
    ],
    "gml": [
        "Latf"
    ],
    "gmm": [
        "Latn"
    ],
    "gmn": [
        "Latn"
    ],
    "gmr": [
        "Latn"
    ],
    "gmu": [
        "Latn"
    ],
    "gmv": [
        "Ethi",
        "Latn"
    ],
    "gmx": [
        "Latn"
    ],
    "gmy": [
        "Linb"
    ],
    "gmz": [
        "Latn"
    ],
    "gn": [
        "Latn"
    ],
    "gna": [
        "Latn"
    ],
    "gnb": [
        "Latn"
    ],
    "gnc": [
        "Latn"
    ],
    "gnd": [
        "Latn"
    ],
    "gne": [
        "Latn"
    ],
    "gng": [
        "Latn"
    ],
    "gnh": [
        "Latn"
    ],
    "gni": [
        "Latn"
    ],
    "gnj": [
        "Latn"
    ],
    "gnk": [
        "Latn"
    ],
    "gnl": [
        "Latn"
    ],
    "gnm": [
        "Latn"
    ],
    "gnn": [
        "Latn"
    ],
    "gnq": [
        "Latn"
    ],
    "gnr": [
        "Latn"
    ],
    "gnt": [
        "Latn"
    ],
    "gnu": [
        "Latn"
    ],
    "gnw": [
        "Latn"
    ],
    "gnz": [
        "Latn"
    ],
    "goa": [
        "Latn"
    ],
    "gob": [
        "Latn"
    ],
    "goc": [
        "Latn"
    ],
    "god": [
        "Latn"
    ],
    "goe": [
        "Tibt"
    ],
    "gof": [
        "Ethi",
        "Latn"
    ],
    "gog": [
        "Latn"
    ],
    "goh": [
        "Latn"
    ],
    "goi": [
        "Latn"
    ],
    "goj": [
        "Zyyy"
    ],
    "gok": [
        "Deva"
    ],
    "gol": [
        "Latn"
    ],
    "gom": [
        "Deva",
        "Knda",
        "Latn"
    ],
    "gon": [
        "Telu",
        "Deva",
        "Gonm"
    ],
    "goo": [
        "Latn"
    ],
    "gop": [
        "Latn"
    ],
    "goq": [
        "Latn"
    ],
    "gor": [
        "Latn"
    ],
    "gos": [
        "Latn"
    ],
    "got": [
        "Goth"
    ],
    "gou": [
        "Latn"
    ],
    "gow": [
        "Latn"
    ],
    "gox": [
        "Latn"
    ],
    "goy": [
        "Latn"
    ],
    "goz": [
        "Zyyy"
    ],
    "gpa": [
        "Latn"
    ],
    "gpe": [
        "Latn"
    ],
    "gpn": [
        "Latn"
    ],
    "gqa": [
        "Latn"
    ],
    "gqi": [
        "Zyyy"
    ],
    "gqn": [
        "Latn"
    ],
    "gqr": [
        "Latn"
    ],
    "gqu": [
        "Zyyy"
    ],
    "gra": [
        "Deva",
        "Gujr"
    ],
    "grb": [
        "Latn"
    ],
    "grc": [
        "Cprt",
        "Grek",
        "Linb"
    ],
    "grd": [
        "Latn"
    ],
    "grg": [
        "Latn"
    ],
    "grh": [
        "Latn"
    ],
    "gri": [
        "Latn"
    ],
    "grj": [
        "Latn"
    ],
    "grm": [
        "Latn"
    ],
    "gro": [
        "Zyyy"
    ],
    "grq": [
        "Latn"
    ],
    "grr": [
        "Zyyy"
    ],
    "grs": [
        "Latn"
    ],
    "grt": [
        "Beng",
        "Brai",
        "Latn"
    ],
    "gru": [
        "Ethi",
        "Latn"
    ],
    "grv": [
        "Latn"
    ],
    "grw": [
        "Latn"
    ],
    "grx": [
        "Latn"
    ],
    "gry": [
        "Latn"
    ],
    "grz": [
        "Latn"
    ],
    "gse": [
        "Zxxx"
    ],
    "gsg": [
        "Zxxx"
    ],
    "gsl": [
        "Latn"
    ],
    "gsm": [
        "Zxxx"
    ],
    "gsn": [
        "Latn"
    ],
    "gso": [
        "Latn"
    ],
    "gsp": [
        "Latn"
    ],
    "gss": [
        "Zxxx"
    ],
    "gsw": [
        "Latn"
    ],
    "gta": [
        "Latn"
    ],
    "gtu": [
        "Latn"
    ],
    "gu": [
        "Gujr",
        "Brai",
        "Khoj"
    ],
    "gua": [
        "Latn"
    ],
    "gub": [
        "Latn"
    ],
    "guc": [
        "Latn"
    ],
    "gud": [
        "Latn"
    ],
    "gue": [
        "Latn"
    ],
    "guf": [
        "Latn"
    ],
    "guh": [
        "Latn"
    ],
    "gui": [
        "Latn"
    ],
    "guk": [
        "Latn",
        "Ethi"
    ],
    "gul": [
        "Latn"
    ],
    "gum": [
        "Latn"
    ],
    "gun": [
        "Latn"
    ],
    "guo": [
        "Latn"
    ],
    "gup": [
        "Latn"
    ],
    "guq": [
        "Latn"
    ],
    "gur": [
        "Latn"
    ],
    "gus": [
        "Zxxx"
    ],
    "gut": [
        "Latn"
    ],
    "guu": [
        "Latn"
    ],
    "guw": [
        "Latn"
    ],
    "gux": [
        "Latn"
    ],
    "guz": [
        "Latn"
    ],
    "gv": [
        "Latn"
    ],
    "gva": [
        "Latn"
    ],
    "gvc": [
        "Latn"
    ],
    "gve": [
        "Latn"
    ],
    "gvf": [
        "Latn"
    ],
    "gvj": [
        "Latn"
    ],
    "gvl": [
        "Latn"
    ],
    "gvm": [
        "Latn"
    ],
    "gvn": [
        "Latn"
    ],
    "gvo": [
        "Latn"
    ],
    "gvp": [
        "Latn"
    ],
    "gvr": [
        "Deva",
        "Latn"
    ],
    "gvs": [
        "Latn"
    ],
    "gvy": [
        "Latn"
    ],
    "gwa": [
        "Latn"
    ],
    "gwb": [
        "Latn"
    ],
    "gwc": [
        "Arab"
    ],
    "gwd": [
        "Latn"
    ],
    "gwe": [
        "Latn"
    ],
    "gwf": [
        "Arab"
    ],
    "gwg": [
        "Latn"
    ],
    "gwi": [
        "Latn"
    ],
    "gwj": [
        "Latn"
    ],
    "gwm": [
        "Latn"
    ],
    "gwn": [
        "Latn"
    ],
    "gwr": [
        "Latn"
    ],
    "gwt": [
        "Arab"
    ],
    "gwu": [
        "Latn"
    ],
    "gww": [
        "Latn"
    ],
    "gwx": [
        "Latn"
    ],
    "gxx": [
        "Latn"
    ],
    "gyb": [
        "Latn"
    ],
    "gyd": [
        "Latn"
    ],
    "gye": [
        "Latn"
    ],
    "gyf": [
        "Latn"
    ],
    "gyg": [
        "Latn"
    ],
    "gyi": [
        "Latn"
    ],
    "gyl": [
        "Zyyy"
    ],
    "gym": [
        "Latn"
    ],
    "gyn": [
        "Latn"
    ],
    "gyo": [
        "Zyyy"
    ],
    "gyr": [
        "Latn"
    ],
    "gyy": [
        "Latn"
    ],
    "gyz": [
        "Latn"
    ],
    "gza": [
        "Latn"
    ],
    "gzi": [
        "Arab"
    ],
    "gzn": [
        "Latn"
    ]
};
